<template>
  <a-card>
    
    <h3 style="text-align: center;margin:20px 0 40px">分阶段具体实施目标</h3>
      <div class="table-toolbar">
          <a-button type="primary" @click="onAdd">
              <template #icon>
                  <plus-outlined/>
              </template>
              新增
          </a-button>
          <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
              <a-button danger>批量删除</a-button>
          </a-popconfirm>
      </div>
      <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
          <template #message>
              已选择 {{ selectedRowKeys.length }} 项
              <a @click="onClearSelected" class="ml-20 float-right">清空</a>
          </template>
      </a-alert>
      <a-table
          :columns="columns"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="pagination"
          :data-source="dataSource"
          :loading="loading"
          @change="onTableChange">
          <template #action="{record}">
              <div class="table-row-operations">
                  <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                  <a @click="onEdit(record)">编辑</a>
              </div>
          </template>
      </a-table>
  </a-card>
  <AddProjectImplementation ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import store from '@/store';
import AddProjectImplementation from "./components/AddProjectImplementation";
import {tableListMixin} from "@/mixins";
import {projectImplementation} from "@/api/TechnologieprojekteApply";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  {title: "开始时间", dataIndex: "startTime", key: "startTime"},
  {title: "结束时间", dataIndex: "endTime", key: "endTime"},
  {title: "实施内容和目标", dataIndex: "contentObjectives", key: "contentObjectives"},
  {title: "合作(协作)单位实施内容和目标", dataIndex: "collaborateContentObjectives", key: "collaborateContentObjectives"},
  {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
  name: "分阶段具体实施目标",
  mixins: [tableListMixin],
  components: {
      AddProjectImplementation
  },
  data() {
      return {
          dictNames: 'isPublic,serviceStatus,condition,demand_type',
          columns,
          queryParam: {projectId: store.getters.TechnologieTypeId.projectId,classification: store.getters.TechnologieTypeId.classification},
          listUrl: projectImplementation.pageList,
          listKeyField: "id",
          deleteUrl: projectImplementation.remove
      }
  },
  methods: {
      onAdd() {
          this.$refs.modal.postForm(store.getters.TechnologieTypeId.projectId,store.getters.TechnologieTypeId.classification)
          this.onShowModal('modal');
      },
      onEdit(record) {
          this.getAction({
              url: projectImplementation.detail,
              params: {id: record.id}
          }).then(res => {
              this.onShowModal('modal', res);
          })
      },
  }
}
</script>

<style scoped>

</style>
